import React from 'react';
import {
  getArrayOfLastThirtyDays,
  getSimpleDateFromISOString,
} from '../../../utils/dateFunctions';
import { Bar, BarChart, CartesianGrid, Legend, Rectangle, Tooltip, XAxis, YAxis } from 'recharts';

export default function TypeBarchart({ amountData, origType }) {
  const thirtyDays = getArrayOfLastThirtyDays();

  let simpleDate = '';
  let searchDate = '';

  thirtyDays.forEach((vol) => {
    vol.volume = 0;
  });

  amountData.length > 0 && thirtyDays.length > 0 && amountData.forEach((data) => {
    searchDate = data.dateTime.slice(0, 10).replaceAll('-', '/');

    thirtyDays.forEach((data2) => {
      simpleDate = getSimpleDateFromISOString(data2);
      data2.date = simpleDate;
      if (searchDate === simpleDate) {
        if (data.activeAmount > 0) {
          data2.volume += Number(data.activeAmount);
        }
      }

    });
  });

  console.log(thirtyDays);

  return (
    <>
      <BarChart
        width={800}
        height={400}
        data={thirtyDays}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" interval={7} />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="volume" fill="#8884d8" name={origType.name + ' (' + origType.activeUnits + ')'}
             activeBar={<Rectangle fill="pink" stroke="blue" />} />
      </BarChart>
    </>);
}